import React from 'react';
import { Routes, Route } from 'react-router-dom';

import OpenPopup from './components/OpenPopup';
import Styleguide from './components/Styleguide';
import ChatContainer from './components/ChatContainer';

import './styles/index.scss';
import Standalone from './components/Standalone';

export function RedirectToDemo(): null {
  window.location.assign('/demo.html');
  return null;
}

function App(): JSX.Element | null {
  return (
    <Routes>
      <Route path="/demo" element={<RedirectToDemo />} />
      <Route path="/open/:customerId" element={<OpenPopup />} />
      <Route path="/standalone/:customerId" element={<Standalone />} />
      <Route path="/styleguide" element={<Styleguide />} />
      <Route path="/" element={<ChatContainer />} />
    </Routes>
  );
}

export default App;
